import type { DiagramProps } from '@/lib/scad-feature-types';
import { D } from './DiagramStyles';

export function Clone1dDiagram({ values }: DiagramProps) {
  const count = Math.max(1, Math.round(values.count ?? 5));
  const spacing = values.spacing ?? [10, 0, 0];
  const sx = spacing[0] ?? 10;
  const sy = spacing[1] ?? 0;

  // Display at most 6 copies
  const displayCount = Math.min(count, 6);
  const dotSpacingX = sx !== 0 ? 38 : 0;
  const dotSpacingY = sy !== 0 ? 20 : 0;
  const useX = Math.abs(sx) >= Math.abs(sy);
  const stepX = useX ? 38 : (dotSpacingX || 20);
  const stepY = useX ? 0 : 22;
  const startX = 28;
  const startY = 75;
  const boxW = 22, boxH = 18;

  return (
    <svg viewBox="0 0 280 150" width="100%" style={{ display: 'block' }} aria-label="1D Clone diagram">
      <defs>
        <marker id="arr-cl1" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
          <path d="M0,1 L5,3 L0,5 Z" fill={D.DIM_STROKE} />
        </marker>
        <marker id="arr-cl1-rev" markerWidth="6" markerHeight="6" refX="1" refY="3" orient="auto">
          <path d="M5,1 L0,3 L5,5 Z" fill={D.DIM_STROKE} />
        </marker>
      </defs>

      {/* Draw each box */}
      {Array.from({ length: displayCount }, (_, i) => {
        const bx = startX + i * stepX;
        const by = startY - boxH / 2 + i * stepY;
        return (
          <g key={i}>
            <rect x={bx} y={by} width={boxW} height={boxH}
                  fill={i === 0 ? D.GEO_FILL : 'rgba(96,165,250,0.08)'}
                  stroke={D.GEO_STROKE}
                  strokeWidth={i === 0 ? 1.5 : 1}
                  strokeDasharray={i === 0 ? 'none' : '3 3'} />
          </g>
        );
      })}

      {/* Spacing arrow between first two */}
      {displayCount >= 2 && (
        <>
          <line x1={startX + boxW} y1={startY + boxH / 2 + 10}
                x2={startX + stepX} y2={startY + boxH / 2 + 10}
                stroke={D.DIM_STROKE} strokeWidth="1" strokeDasharray={D.DIM_DASH}
                markerEnd="url(#arr-cl1)" markerStart="url(#arr-cl1-rev)" />
          <text x={startX + boxW + stepX / 2 - boxW / 2}
                y={startY + boxH / 2 + 22}
                fontSize="10" fontFamily="monospace"
                fill={D.DIM_STROKE} textAnchor="middle" opacity="0.85">
            spacing
          </text>
        </>
      )}

      {/* Count badge */}
      <text x={startX + (displayCount - 1) * stepX + boxW + 10}
            y={startY + 4}
            fontSize="11" fontFamily="monospace"
            fill={D.X_COLOR} opacity="0.9">
        ×{count}
      </text>

      {/* Vector direction arrow */}
      <text x="8" y="142" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.45">
        spacing = [{sx}, {spacing[1] ?? 0}, {spacing[2] ?? 0}]  count = {count}
      </text>
    </svg>
  );
}
